export default __webpack_public_path__ + "static/media/Icon-WorkOrder.18c60c41.svg";